import { MoreVertical, Send, Save, Layers, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface PlanActionsMenuProps {
  onSharePlan: () => void
  onSaveVersion: () => void
  onManageVersions: () => void
  onDeletePlan: () => void
}

export function PlanActionsMenu({
  onSharePlan,
  onSaveVersion,
  onManageVersions,
  onDeletePlan,
}: PlanActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="h-9 w-9 cursor-pointer"
          title="More actions"
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onSharePlan} className="cursor-pointer">
          <Send className="mr-2 h-4 w-4" />
          <span>Share Plan</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={onSaveVersion}
          className="cursor-pointer text-primary focus:text-primary"
        >
          <Save className="mr-2 h-4 w-4" />
          <span>Save Version</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onManageVersions} className="cursor-pointer">
          <Layers className="mr-2 h-4 w-4" />
          <span>Manage Versions</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={onDeletePlan}
          className="cursor-pointer text-destructive focus:text-destructive"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          <span>Delete Plan</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
